
<script>
import iban from "@/mixins/iban";
const dev = process.env.VUE_APP_DEV

export default {
  name: "FormValidationMixin",
  data:() => ({
  }),
  methods: {
    requiredRule:(text) => value => {
      if (dev || value?.length>0) return true; return text
    },
    emailRule:(text) => value => {
      if (dev || /.+@.+\..+/.test(value)) return true
      return text
    },
    requiredCheckbox:(text) => value => {
      if (dev || (value && value===true)) return true; return text
    },
    ibanRule:(text) => value => {
        if (dev || iban.Validate(value)===1) return true; return text
    },



  },
}
</script>

<style scoped>

</style>